import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const TableData = () => {
  const location = useLocation();
  // console.log(typeof(location?.state),"++++++++++")
  const rights = useSelector((state) => state.layout.right);
  const role = useSelector((state) => state?.layout?.role);
  return {
    tableTitle: "Videos",
    onDeleteText: "Are you Sure?",
    deleteAccess: rights?.["Movie"]?.["delete"] == "true",
    onUpdateText: "Are you Sure?",
    tableHead: [
      {
        id: "movie_name",
        label: "Name",
        link: "/Movie/MovieDetails",
        color: "var(--gradientColor2)",
        subText: "movie_subcategory",
      },
      {
        id: 'movie_ownership',
        label: 'Ownership',
        // subText:"publish_time1"
      },
      {
        id: "movie_poster",
        label: "Image",
        isImage: true,
      },
     
      {
        id: "genre",
        label: "Genre",
        subText1: "genre1",
      },
      

     
      {
        id: "movie_access",
        label: "Access",
      },
      {
        id: "movie_language",
        label: "Language",
      },
      {
        id: "rental_count",
        label: "Total Rental",
        align: "center",
      },

      {
        id: "movieViews",
        label: "Views",
        align: "center",
      },
      

      {
        id: "status",
        label: "Status",
        isButtonDisplay: true,

      },

      role !== "Distributor" && {
        id: "edit",
        label: "Update",
        access: rights?.["Movie"]?.["edit"] == "true"
      },
    ].filter((e) => e),
    tableBody: [],
    filterColumn: [
    
      // {
      //   title: undefined
      // },
{
        id: "2",
        title: "Language",
        name: "movie_language",
        options: ["English", "Hindi", "Gujarati"],
      },
      {
        id: "3",
        title: "Category",
        name: "movie_category",
        default:
          typeof location?.state != "object" && location.state == null
            ? location?.state
            : null,
        options: ["Action", "Comedy", "Drama", "Horror"],
      },
      {
        id: "3",
        title: "Sub Category",
        name: "movie_subcategory",
        options: ["Action", "Comedy", "Drama", "Horror"],
        displayOn: "movie_category",
      },
      role !== "Distributor" && {
        id: "1",
      title: "Ownership",
      name: "movie_ownership",
      options:["In house","Collaborator"],
      },
    ].filter((e)=>e),
  };
};
